import React, { Component } from 'react';
import FilterPanel from './FilterPanel';


import { NumericFormat } from 'react-number-format';

import {isReactComponent} from '../../utils/common';

import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache
} from 'react-virtualized';

export default class MobileGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.cache = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 300
    });
  }

  onColumnEdit = (event, column, row, rowIndex) => {
    if (this.props.onGridRowsUpdated) {
      const updated = {};
      updated[column.key] = event.target.value;
      this.props.onGridRowsUpdated({
        fromRow: rowIndex,
        toRow: rowIndex,
        updated
      });
    }
  };

  renderColumn = (column, columnIndex, row, rowIndex) => {
    const value = row[column.key];

    
    const getFormattedValue = () => {
      
      if(column.formatter && isReactComponent(column.formatter)){

        var FormatterComponent = column.formatter;
        return <FormatterComponent value={row[column.key]} />
      }

      return column.formatter && typeof column.formatter==='function'
        ? column.formatter({ value, row })
        : row[column.key];
    };

    if (!column.name && !getFormattedValue()) return null;

    if (column.editable) {
      const inputType = column.inputType ? column.inputType : 'text';
      return (
        <tr key={'row' + columnIndex + column.key}>
          <td>{column.name}</td>
          <td>
            {inputType === 'number' ? (
              <NumericFormat
                value={value}
                allowNegative={false}
                prefix={'$'}
                onValueChange={e => {
                  let v = { target: { value: e.floatValue } };
                  this.onColumnEdit(v, column, row, rowIndex);
                }}
              />
            ) : (
              <input
                type={inputType}
                value={value}
                onChange={e => {
                  this.onColumnEdit(e, column, row, rowIndex);
                }}
              />
            )}
          </td>
        </tr>
      );
    } else {
      return (
        <tr key={'row' + columnIndex + column.key}>
          <td>{column.name}</td>
          <td>{getFormattedValue()}</td>
        </tr>
      );
    }
  };

  renderRow = ({ index, key, style, parent }) => {
    const record = this.props.rowGetter(index);
    const rowIndex = index;
    return (
      <CellMeasurer
        key={key}
        cache={this.cache}
        parent={parent}
        columnIndex={0}
        rowIndex={index}
      >
        <div style={style}>
          <div
            key={`mobileGridPanel_${index}`}
            className="panel panel-default"
            style={{
              marginBottom: 20,
              marginTop: 20,
              boxShadow: '3px 3px 2px darkgray'
            }}
          >
            {this.props.panelHeaderRenderer &&
            typeof this.props.panelHeaderRenderer === 'function' ? (
              <div className="panel-heading">
                {this.props.panelHeaderRenderer(record)}
              </div>
            ) : null}

            <table className="table table-condensed">
              <thead>
                <tr />
              </thead>
              <tbody>
                {this.props.columns.map((col, index) => {
                  return this.renderColumn(col, index, record, rowIndex);
                })}
              </tbody>
            </table>
          </div>
        </div>
      </CellMeasurer>
    );
  };

  

  render() {

    return (
      <div className="mobile-grid-wrapper">
        <FilterPanel
          columns={this.props.columns}
          getValidFilterValues={this.props.getValidFilterValues}
          onChange={this.props.onAddFilter}
          onQueryChange={this.props.onQueryChange}
          filters={this.props.filters}
          onClearFilters={()=>{this.props.onClearFilters();}}
        />
        <div className="data-list">
          <AutoSizer>
            {({ width, height }) => {
              return (
                <List
                {...this.props}
                  width={width}
                  height={height}
                  rowHeight={this.cache.rowHeight}
                  rowRenderer={this.renderRow}
                  rowCount={this.props.rowsCount}
                 // hasBeenChanged={this.props.changed}
                  
                />
              );
            }}
          </AutoSizer>
        </div>
      </div>
    );
  }
}
